export default "__VITE_ASSET__S96p1av3__"